import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import { Refresh } from "@mui/icons-material";
import DivExist from "./DivExist";
import { Tooltip, CircularProgress } from "@mui/material";

/**
 *
 * @param {object} param0
 * @param {function} param0.onBtnClick
 * @param {boolean} param0.hide
 * @param {"large"|"medium"|"small"} param0.size
 * @param {boolean} param0.disabled
 * @param {'inherit'|'primary'|'secondary'|'success'|'error'|'info'|'warning'} param0.color
 * @param {string} param0.tooltip
 * @param {boolean} param0.withProcessing
 * @returns
 */
export default function IconButtonRefresh({
  onBtnClick,
  hide,
  size = "large",
  disabled,
  color,
  tooltip,
  withProcessing
}) {
  const [processing, setProcessing] = useState(false);
  return (
    <DivExist show={!hide}>
      <DivExist show={!withProcessing || (withProcessing && !processing)}>
        <Tooltip title={tooltip || ""}>
          <IconButton
            onClick={async () => {
              let t;
              if (withProcessing) {
                setProcessing(true);
                t = setTimeout(() => {
                  setProcessing(false);
                }, 5000);
              }
              await onBtnClick();
              if (withProcessing) {
                setProcessing(false);
                clearTimeout(t);
              }
            }}
            size={size}
            disabled={disabled}
            color={color}
          >
            <Refresh fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </DivExist>
      <DivExist show={withProcessing && processing}>
        <CircularProgress size={size === "large" ? 25 : size === "medium" ? 20 : 15} />
      </DivExist>
    </DivExist>
  );
}
